
import { UserConfigService } from "@/services/user-config-service";
import { DossierConfigService } from "@/services/dossier-config-service";
import { AuthService } from "@/services/auth-service";
import AppSaleTypeMultiSelect from "@/components/sales/SaleTypeMultiSelect.vue";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			settings: UserConfigService.getGeneralSettings(),
			dossierConfig: DossierConfigService.getGeneralConfig(),
			notificationEmails: [] as string[],
		};
	},
	computed: {
		path():IBreadCrumb[] {
			return [
				{
					to: "/settings",
					value: this.$ct("general")
				},
				{
					value: this.$ct("notifications")
				}
			] as IBreadCrumb[];
		},
		isOwner():boolean {
			return AuthService.wfCompany.OwnerID == AuthService.wfUser.ID;
		},
		userEmail():string {
			return AuthService.wfUser.Email || "";
		},
		peppolNotificationEmail():string {
			return this.settings.PeppolNotificationEmail || this.userEmail;
		},
		isDevMode():boolean {
			return AuthService.isDevModeEnabled;
		}
	},
	methods: {
		async updateSettings() {
			await UserConfigService.setGeneralSettings(this.settings);
		},
		async updateDossierConfig() {
			this.dossierConfig = await DossierConfigService.saveGeneralConfig(this.dossierConfig);
		},
		onFrequencyDocumentCreatedChanged(value:boolean) {
			this.settings.NotifyOnFrequencyDocumentCreated = value;
			this.updateSettings();
		},
		onFrequencyDocumentSentChanged(value:boolean) {
			this.settings.NotifyOnFrequencyDocumentSent = value;
			this.updateSettings();
		},
		onReminderSentChanged(value:boolean) {
			this.settings.NotifyOnReminderSent = value;
			this.updateSettings();
		},
		onPeppolReceiveChanged(value:boolean) {
			this.settings.NotifyOnPeppolReceive = value;
			this.updateSettings();
		},
		onEmailPeppolReceiveChanged(value:boolean) {
			this.settings.EmailNotifyOnPeppolReceive = value;
			this.updateSettings();
		},
		onPeppolNotificationEmailChanged(value:string) {
			this.settings.PeppolNotificationEmail = value;
		},
		onNotifyTypesChanged() {
			this.updateDossierConfig();
		},
		onEmailTypesChanged() {
			this.updateDossierConfig();
		},
		parseEmails() {
			const emailStr = this.dossierConfig.SaleDeleteNotificationEmails || "";
			this.notificationEmails = emailStr.split(",").map(e => e.trim()).filter(e => e !== "");
			if (this.notificationEmails.length === 0) {
				this.notificationEmails.push("");
			}
		},
		syncEmailsToConfig() {
			this.dossierConfig.SaleDeleteNotificationEmails = this.notificationEmails.filter(e => e.trim() !== "").join(",");
		},
		onEmailInput(index: number, value: string) {
			this.$set(this.notificationEmails, index, value);
			this.syncEmailsToConfig();
		},
		onEmailBlur() {
			this.updateDossierConfig();
		},
		onEmailKeyDown(event: KeyboardEvent) {
			if (event.key === "," || event.key === ";" || event.key === " ") {
				event.preventDefault();
				this.addEmail();
			}
		},
		async addEmail() {
			this.notificationEmails.push("");
			await this.$nextTick();
			const inputs = this.$refs.emailInputs as any[];
			if (inputs && inputs.length > 0) {
				inputs[inputs.length - 1].focus();
			}
		},
		removeEmail(index: number) {
			this.notificationEmails.splice(index, 1);
			if (this.notificationEmails.length === 0) {
				this.notificationEmails.push("");
			}
			this.syncEmailsToConfig();
			this.updateDossierConfig();
		},
		onConfigsUpdated() {
			this.settings = UserConfigService.getGeneralSettings();
			this.dossierConfig = DossierConfigService.getGeneralConfig();
			this.parseEmails();
		}
	},
	created() {
		UserConfigService.on("configs-updated", this.onConfigsUpdated);
		this.parseEmails();
	},
	destroyed() {
		UserConfigService.off("configs-updated", this.onConfigsUpdated);
	},
	components: {
		AppSaleTypeMultiSelect
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
});
